let router;

export function initRouter (initRouter) {
  router = initRouter;
}

export function useRouter () {
  return router;
}
